import React, { useState } from 'react';

// http axios
import axios from 'axios';
import axiosUrl from '../../../axios/url';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';



export default function SliderViewer(prop) {

    const [sliderList, setSliderList] = useState([]);

    // 콘텐츠 정보 가져오기
    async function getCards(id){

        var url = axiosUrl.cards + '/' + id;
        await axios.get(url)
        .then( res => {
            console.log(res.data);
            setSliderList(res.data.cards);
            // document.getElementById('viewer').innerHTML = res.data.blog.body;
        })
        .catch(function (e) {
            alert('존재하지 않는 콘텐츠입니다. 확인 후 다시 시도하세요.');
            window.location.href='/signin';
        });
    }


    React.useEffect(() => {
        const id = prop.match.params.id;

        if( id === '' || id === null) window.location = '/';
        else getCards(prop.match.params.id);
    }, []);

    return(
        
        <div className="text-center mt-5">
          <Slider >
                {sliderList.map((item, index) => (
                    <div
                        key={index}
                        // style={{ background: `url('${item.imageUrl}') no-repeat center center / 100%` }}
                    >   <img src={item.imageUrl} style={{ width: `auto`, height: `100%`, display: `block`, marginLeft: `auto`, marginRight: `auto` }}></img> 
                        {/* <div className="center">
                            
                            <h1>{item.title}</h1>
                            <p>{item.content}</p>
                        </div> */}
                    </div>
                ))}
            </Slider>
        </div>

    );
}